module.exports = __webpack_public_path__ + "static/media/view1.449a1faa.jpeg";